(function ($) {
    $(document).ready(function () {
        // console.log('ready');
       $('.list-grid .social-media-sharing .share.twitter img').hover(function () {
           // console.log('hover');
           // var oldSrc= $(this).attr('src');
           //  console.log(oldSrc);
            $(this).attr('src','/themes/custom/heatandcontrol/templates/dist/images/blog-social-icon/Twitter_red.svg');
       });
        $('.list-grid .social-media-sharing .share.twitter img').mouseout(function () {
            $(this).attr('src','/themes/custom/heatandcontrol/templates/dist/images/blog-social-icon/Twitter_gray.svg');
        });

        $('.list-grid .social-media-sharing .share.facebook-share img').hover(function () {
            // console.log('hover');
            // var oldSrc= $(this).attr('src');
            //  console.log(oldSrc);
            $(this).attr('src','/themes/custom/heatandcontrol/templates/dist/images/blog-social-icon/fb_red.svg');
        });
        $('.list-grid .social-media-sharing .share.facebook-share img').mouseout(function () {
            $(this).attr('src','/themes/custom/heatandcontrol/templates/dist/images/blog-social-icon/fb_gray.svg');
        });

        $('.list-grid .social-media-sharing .share.linkedin img').hover(function () {
            // console.log('hover');
            // var oldSrc= $(this).attr('src');
            //  console.log(oldSrc);
            $(this).attr('src','/themes/custom/heatandcontrol/templates/dist/images/blog-social-icon/LinkedIn_red.svg');
        });
        $('.list-grid .social-media-sharing .share.linkedin img').mouseout(function () {
            $(this).attr('src','/themes/custom/heatandcontrol/templates/dist/images/blog-social-icon/LinkedIn_gray.svg');
        });

        $('.list-grid .social-media-sharing .share.email img').hover(function () {
            // console.log('hover');
            // var oldSrc= $(this).attr('src');
            //  console.log(oldSrc);
            $(this).attr('src','/themes/custom/heatandcontrol/templates/dist/images/blog-social-icon/Email_red.svg');
        });
        $('.list-grid .social-media-sharing .share.email img').mouseout(function () {
            $(this).attr('src','/themes/custom/heatandcontrol/templates/dist/images/blog-social-icon/Email_gray.svg');
        });
    });
})(jQuery);